interface IconProps {
  fillColor: string
}

export const PendingSignatoriesIcon = ({ fillColor }: IconProps) => {
  return (
    <div className="illustration__icon-wrapper">
      <svg
        width="120"
        height="120"
        viewBox="0 0 120 120"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M84.8555 79.1999C85.298 78.7574 86.0157 78.7563 86.4583 79.1986C86.9008 79.641 86.9004 80.3588 86.4583 80.8014L83.763 83.4954L86.4583 86.1895C86.9007 86.6321 86.9009 87.3498 86.4583 87.7923C86.0158 88.2348 85.2981 88.2347 84.8555 87.7923L82.1615 85.097L79.4674 87.7923C79.0249 88.2345 78.3084 88.2345 77.8659 87.7923C77.4233 87.3497 77.4233 86.632 77.8659 86.1895L80.5586 83.4954L77.8659 80.8014C77.4233 80.3588 77.4233 79.6425 77.8659 79.1999C78.3085 78.7573 79.0249 78.7573 79.4674 79.1999L82.1615 81.8926L84.8555 79.1999Z"
          fill={fillColor}
        />
        <path
          d="M62.6667 81.5345C63.2926 81.5345 63.7995 82.0414 63.7995 82.6673C63.7995 83.2932 63.2926 83.8001 62.6667 83.8001H45.3333C44.7074 83.8001 44.2005 83.2932 44.2005 82.6673C44.2005 82.0414 44.7074 81.5345 45.3333 81.5345H62.6667Z"
          fill={fillColor}
        />
        <path
          d="M54.6667 74.8678C55.2926 74.8678 55.7995 75.3747 55.7995 76.0007C55.7995 76.6266 55.2926 77.1335 54.6667 77.1335H45.3333C44.7074 77.1335 44.2005 76.6266 44.2005 76.0007C44.2005 75.3747 44.7074 74.8678 45.3333 74.8678H54.6667Z"
          fill={fillColor}
        />
        <path
          d="M62.6667 68.2012C63.2926 68.2012 63.7995 68.7081 63.7995 69.334C63.7995 69.9599 63.2926 70.4668 62.6667 70.4668H45.3333C44.7074 70.4668 44.2005 69.9599 44.2005 69.334C44.2005 68.7081 44.7074 68.2012 45.3333 68.2012H62.6667Z"
          fill={fillColor}
        />
        <path
          d="M74.6667 61.5345C75.2926 61.5345 75.7995 62.0414 75.7995 62.6673C75.7995 63.2932 75.2926 63.8001 74.6667 63.8001H45.3333C44.7074 63.8001 44.2005 63.2932 44.2005 62.6673C44.2005 62.0414 44.7074 61.5345 45.3333 61.5345H74.6667Z"
          fill={fillColor}
        />
        <path
          d="M74.6667 54.8678C75.2926 54.8678 75.7995 55.3747 75.7995 56.0007C75.7995 56.6266 75.2926 57.1335 74.6667 57.1335H45.3333C44.7074 57.1335 44.2005 56.6266 44.2005 56.0007C44.2005 55.3747 44.7074 54.8678 45.3333 54.8678H74.6667Z"
          fill={fillColor}
        />
        <path
          d="M74.6667 48.2012C75.2926 48.2012 75.7995 48.7081 75.7995 49.334C75.7995 49.9599 75.2926 50.4668 74.6667 50.4668H45.3333C44.7074 50.4668 44.2005 49.9599 44.2005 49.334C44.2005 48.7081 44.7074 48.2012 45.3333 48.2012H74.6667Z"
          fill={fillColor}
        />
        <path
          d="M54.6667 41.5345C55.2926 41.5345 55.7995 42.0414 55.7995 42.6673C55.7995 43.2932 55.2926 43.8001 54.6667 43.8001H45.3333C44.7074 43.8001 44.2005 43.2932 44.2005 42.6673C44.2005 42.0414 44.7074 41.5345 45.3333 41.5345H54.6667Z"
          fill={fillColor}
        />
        <path
          d="M70.6667 33.5345C71.2926 33.5345 71.7995 34.0414 71.7995 34.6673V41.5345H78.6667C79.2926 41.5345 79.7995 42.0414 79.7995 42.6673C79.7995 43.2932 79.2926 43.8001 78.6667 43.8001H69.5339V34.6673C69.5339 34.0414 70.0407 33.5345 70.6667 33.5345Z"
          fill={fillColor}
        />
        <path
          d="M62.6667 34.8678C63.2926 34.8678 63.7995 35.3747 63.7995 36.0007C63.7995 36.6266 63.2926 37.1335 62.6667 37.1335H45.3333C44.7074 37.1335 44.2005 36.6266 44.2005 36.0007C44.2005 35.3747 44.7074 34.8678 45.3333 34.8678H62.6667Z"
          fill={fillColor}
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M72.8008 28.5332L84.8008 40.5332L85.1328 40.8639V71.2637C90.5044 72.6516 94.4661 77.5267 94.4661 83.334C94.4661 90.2137 88.8911 95.8001 82 95.8001C78.3804 95.8001 75.1253 94.2597 72.849 91.8001H40C37.1649 91.8001 34.8672 89.5024 34.8672 86.6673V33.334C34.8672 30.4989 37.1649 28.2012 40 28.2012H72.4701L72.8008 28.5332ZM82 73.1335C76.3614 73.1335 71.7995 77.6964 71.7995 83.334C71.7995 88.9715 76.3614 93.5345 82 93.5345C87.638 93.5345 92.2005 88.9631 92.2005 83.334C92.2005 77.6964 87.6386 73.1335 82 73.1335ZM40 30.4668C38.4168 30.4668 37.1328 31.7508 37.1328 33.334V86.6673C37.1328 88.2505 38.4168 89.5345 40 89.5345H71.1849C70.1365 87.7083 69.5339 85.5926 69.5339 83.334C69.5339 76.4447 75.1094 70.8678 82 70.8678C82.2916 70.8678 82.5806 70.8807 82.8672 70.9004V41.8027L71.5312 30.4668H40Z"
          fill={fillColor}
        />
      </svg>
    </div>
  )
}
